import React from 'react';
import SectionTitle from '../../components/SectionTitle';
import SingleFeature from '../../components/Feature';

import featureImg1 from '../../assets/img/slider/gemasan-8.svg';
import featureImg2 from '../../assets/img/slider/gemasan-12.svg';
import featureImg3 from '../../assets/img/slider/gemasan-9.svg';

const Feature = () => {
  return (
    <div className="feature__area feature__mlr pt-100 pb-70">
      <div className="container-fluid">
        <div className="row justify-content-center">
          <div
            className="col-xl-6 wow animate__fadeInUp"
            data-wow-duration="1.1s"
          >
            <SectionTitle
              subTitle="Ürünlerimiz"
              Title="Denizlerin Geleceğini Tasarlıyoruz"
            />
          </div>
        </div>
        <div className="row">
          <div
            className="col-xl-4 col-lg-6 col-md-6 mb-30 wow animate__fadeInUp"
            data-wow-duration="1.1s"
            data-wow-delay=".5s"
          >
            <SingleFeature
              itemClass="feature__item feature__color-1 text-center"
              Image={featureImg1}
              Title="Su Altı Robotu (ROV)"
              Description="Gemilerin su altında kalan kısımlarının bakımı ve temizlik süreçlerinde aktif rol oynayan insansız su altı robotu. Operasyonel verimliliği artıran, derin deniz koşullarına dayanıklı teknoloji."
              btnText="Detaylar"
            />
          </div>
          <div
            className="col-xl-4 col-lg-6 col-md-6 mb-30 wow animate__fadeInUp"
            data-wow-duration="1.1s"
            data-wow-delay=".7s"
          >
            <SingleFeature
              itemClass="feature__item feature__color-2 text-center"
              Image={featureImg3}
              Title="Robot Kol"
              Description="Kesme, kavrama, kurtarma ve onarım gibi görevleri yerine getirebilen çok fonksiyonlu, modüler yapıda ve yüksek hassasiyetli manipülatör sistemi."
              btnText="Detaylar"
              btnURL="/robotkol"
            />
          </div>
          <div
            className="col-xl-4 col-lg-6 col-md-6 mb-30 wow animate__fadeInUp"
            data-wow-duration="1.1s"
            data-wow-delay=".9s"
          >
            <SingleFeature
              itemClass="feature__item feature__color-3 text-center"
              Image={featureImg2}
              Title="Yapay Zeka Destekli Seyir Sistemi"
              Description="Gündüz ve gece koşullarında çalışan, nesne tespiti ve takibi yaparak çarpışma risklerini önceden belirleyen otonom seyir destek sistemi."
              btnText="Detaylar"
              btnURL="/seyir"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Feature;
